import type { ExpressionSpecification } from 'mapbox-gl';
import { COLOR_NEUTRAL_1000, COLOR_PURPLE_300, COLOR_PURPLE_600 } from '@alltrails/denali/tokens';

/** Properties of the `trail_segments_tiles` view in at_geo_service. The feature id is `id`. */
export type TrailSegmentProperties = {
  id: number;
  ds_id: number;
  status: string;
  at_name?: string;
  mtb_difficulty?: string;
  /**
   * Mock only, not a column of the view: the verified trail this segment belongs to, until that link exists.
   * TODO(https://alltrails.atlassian.net/browse/MAPS-519): Remove, or replace with the backend's link to a verified trail.
   */
  verified_trail_id?: number;
};

// TODO(https://alltrails.atlassian.net/browse/MAPS-519): Confirm this matches the zoom range the trail segments tiles serve.
export const trailSegmentsMinZoom = 10;
export const trailSegmentsMaxZoom = 22;

// Unselected segments are a dashed line over a light, low-opacity halo; a selected segment is a solid black line.
export const trailSegmentsDashColor = COLOR_PURPLE_600;
export const trailSegmentsHaloColor = COLOR_PURPLE_300;
export const trailSegmentsSelectedColor = COLOR_NEUTRAL_1000;

export const isTrailSegmentSelectedExpression: ExpressionSpecification = ['boolean', ['feature-state', 'selected'], false];
